export enum MessageDeletionType {
  Author = 'author',
  Admin = 'admin',
}
